import { Drawer } from '@mui/material'
import { Button, Checkbox } from '@nextui-org/react'
import { IconFileText, IconPencil, IconPlus, IconSparkles, IconX } from '@tabler/icons-react';
import React, { Fragment, useState } from 'react'
import { useForm } from 'react-hook-form';
import InputMaster from './InputMaster';
import SelectMaster from './SelectMaster';
import { yupResolver } from '@hookform/resolvers/yup';
import { generateValidationSchema } from '../utils/validationSchema';
import { Edit3 } from 'lucide-react';
import SparkleButton from './SparkleButton';
import { useApi } from './ApiProvider';

const DrawerComponent = ({data, edit, entityForm, inputFields, btnName, header, vessel_id, vesselEdit}) => {

    const { setApiDataAndNotify } = useApi()
    const [isLoading, setIsLoading] = useState(false)
    const [open, setOpen] = useState(false);

    const {control, handleSubmit, reset, formState: {errors}, register, setValue, watch, setError} = useForm({
        resolver: yupResolver(generateValidationSchema(inputFields))
    });

    const openDrawer =()=>{
        document.body.style.overflow = 'hidden';
        document.body.style.height = '100vh';
        if(edit){
            reset(data)
        }
        reset()
        setOpen(true);
    };

    const closeDrawer =()=>{
        document.body.style.overflow = 'auto';
        document.body.style.height = 'auto';
        setOpen(false);
    };

    const onSubmit = async(data)=>{
        setIsLoading(true)
        if(vessel_id){
            data.vessel_id = vessel_id
        }
        if(edit){
            await entityForm.mutateAsync(data)
            closeDrawer()
        }else{
            await entityForm.mutateAsync(data).then((res)=>{
                if(res?.success){
                    closeDrawer()
                    reset()
                }else if(res?.isLimitOver){
                    closeDrawer()
                    reset()
                    setApiDataAndNotify(new Date())
                }else{
                    if(res?.error && res?.error?.length > 0){
                        res?.error?.map((item) => {
                            Object.keys(item).map((key) => {
                                setError(key, {
                                    type: "manual",
                                    message: item[key]
                                })
                            })
                        })
                    }
                }
            })
        }
        setIsLoading(false)
    }

  return (
    <Fragment>
        {
            vesselEdit ?
            <Button 
            onClick={openDrawer}
            className="bg-white/20 backdrop-blur-lg border border-white/30 text-white font-medium px-6 py-3 rounded-full hover:bg-white/30 transition-all shadow-xl" 
            size="lg"
            >
                <Edit3 className="h-5 w-5 mr-2" />
                Edit Details
            </Button> :
            <SparkleButton
            isIconOnly={edit ? true : false}
            Icon={edit ? IconPencil : IconPlus}
            btnName={btnName}
            handleClick={openDrawer}
            />
        }
        <Drawer
        open={open}
        anchor='right'
        onClose={()=>closeDrawer()}
        sx={{
        '& .MuiDrawer-paper': {
        width: '400px',
        maxWidth: '400px',
        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
        border: 'none',
        zIndex: 9999
        },
        }}
        >
            <div>
                <div className='flex justify-between font-medium items-center h-[70px] px-6 gap-3 border-b border-[#E6E6E8]'>
                    <h3>{header}</h3>
                    <button onClick={closeDrawer}>
                        <IconX size="20" />
                    </button>
                </div>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className='p-6 text-[12] flex flex-col gap-[6px]'>
                        {
                            inputFields?.map((item, index)=> {
                                if(item?.hide){
                                    return
                                }
                                if(item?.isLabelOnly){
                                    return(
                                       <div className="text-[12px] h-4 font-[500] mb-[1px]">{item?.label}</div>
                                    )
                                }
                                if(item?.type === 'select'){
                                    return (
                                        <SelectMaster key={index} control={control} item={item} errors={errors} />
                                    )
                                }
                                if(item?.type === 'checkbox'){
                                    const isChecked = watch(item?.name) === "YES"
                                    return (
                                        <Checkbox 
                                        defaultSelected={isChecked}
                                        onChange={(e)=> {
                                            item?.setState && item?.setState(e.target.checked)
                                            setValue(item?.name, e.target.checked ? "YES" : "NO")
                                        }}
                                        key={index}
                                        item={item}
                                        >
                                            <span className='text-[12px] font-[500]'>
                                                {item.label}
                                            </span>
                                        </Checkbox>
                                    )
                                }
                                return (
                                    <InputMaster key={index} register={register} item={item} errors={errors} />
                                )
                            })
                        }
                        <div className='flex justify-end mt-2'>
                            <Button type='submit' className='text-white bg-primaryGradient  rounded-[7px] font-semibold'>
                                {isLoading ? "Loading..." : "Save"}
                            </Button>
                        </div>
                    </div>
                </form>
            </div>
        </Drawer>
    </Fragment>
  )
}

export default DrawerComponent